export default __webpack_public_path__ + "static/media/icon_campaign.88a6c3ad.svg";